import { clsx } from 'clsx';

interface ClassVersionTagProps {
  /** Tag name. */
  name: string;

  /** Tag description. */
  description: string;
}

export function ClassVersionTag({ description }: ClassVersionTagProps) {
  const classes = clsx(
    'bg-[#E2EDFF] text-black border border-ds-border inline-block px-2 py-1 font-semibold text-sm leading-4 rounded'
  );

  return <span className={classes}>{description}</span>;
}
